import { useState, useEffect } from 'react';

import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { IntegrationField } from 'components/IntegrationField';
import { Loading } from 'components/Loading';
import { ADManagerJobApp } from 'integrations/adManager/job-app-page';
import { HireflixJobApp } from 'integrations/hireflix/JobAppPage';
import { OneCRMJobPage } from 'integrations/onecrm/job-page';
import { HladanJobPage } from 'integrations/reykjavik/job-page';

function IntegrationForm({ integration, t }) {
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    integration.loadForJob();
  }, [integration]);

  async function submit() {
    setSaving(true);
    if (integration.isValid()) {
      await integration.submitForJob();
    }
    setSaving(false);
  }

  if (integration.name === 'Hireflix') {
    return <HireflixJobApp />;
  }

  if (integration.name === 'AD Manager') {
    return <ADManagerJobApp />;
  }

  if (integration.name === 'OneCRM') {
    return <OneCRMJobPage />;
  }

  if (integration.name === 'Hlaðan') {
    return <HladanJobPage />;
  }

  return (
    <Stack space={6}>
      <div>
        <Text font="heading2">{integration.title}</Text>
        <Text>{integration.description}</Text>
      </div>
      {(integration.state === 'loading' || saving) && <Loading />}
      {integration.state === 'loaded' && (
        <>
          <Stack space={4}>
            {integration.data.map((data, i) => (
              <IntegrationField data={data} key={i} />
            ))}
          </Stack>
          <Stack orientation="horizontal" space={2} justify="flex-end">
            <Button onClick={submit} text={t('job.integrations.button.submit')} />
          </Stack>
        </>
      )}
    </Stack>
  );
}
export default observer(IntegrationForm);
